<template>
  <div class="batch-in-stock">
    <el-tabs v-model="activeTabName" type="page-card">
      <el-tab-pane
        name="createAndInStock"
        label="新建车辆"
        desc="批量录入车辆基础信息"
      >
        <div class="tab-pane">
          <div class="entry-list">
            <div class="entry-row">
              <p class="entry-title">批量录入车辆</p>
              <p class="entry-desc">
                系统中没有此车辆信息，支持批量录入车辆信息。如果车辆已在库，则自动入库完成。
              </p>
              <el-button
                class="entry-btn"
                type="primary"
                icon="el-icon-plus"
                plain
                @click="handleBatchImportCarInfo"
                >批量录入车辆</el-button
              >
            </div>
            <div class="entry-row">
              <p class="entry-title">查看录入记录</p>
              <p class="entry-desc">查看已提交的任务记录录入进度。</p>
              <el-button
                class="entry-btn"
                type="primary"
                icon="el-icon-time"
                plain
                @click="handleViewImportCarLog"
                >查看录入记录</el-button
              >
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane
        name="licenseTransact"
        label="车辆证照办理"
        desc="办理行驶证、网约车证及登记证后上传证照信息"
      >
        <div class="tab-pane">
          <div class="entry-list">
            <div class="entry-row">
              <p class="entry-title">批量录入证照</p>
              <p class="entry-desc">
                批量导入车辆的行驶证、网约车证及登记证照片。导入行驶证、网约车证可结合OCR功能使用，同步更新相关的证件内容。
              </p>
              <el-button
                class="entry-btn"
                type="primary"
                icon="el-icon-plus"
                plain
                @click="handleBatchImportLicense"
                >批量录入证照</el-button
              >
            </div>
            <div class="entry-row">
              <p class="entry-title">查看录入记录</p>
              <p class="entry-desc">查看已提交的任务记录导入进度。</p>
              <el-button
                class="entry-btn"
                type="primary"
                icon="el-icon-time"
                plain
                @click="handleViewImportLicenseLog"
                >查看录入记录</el-button
              >
            </div>
            <div class="entry-row hidden"></div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane
        name="insuranceTransact"
        label="车辆保险办理"
        desc="办理交强险、商业险等险种后上传保险信息"
      >
        <div class="tab-pane">
          <div class="entry-list">
            <div class="entry-row">
              <p class="entry-title">批量录入保单</p>
              <p class="entry-desc">批量新增车辆的保单信息。</p>
              <el-button
                class="entry-btn"
                type="primary"
                icon="el-icon-plus"
                plain
                @click="handleBatchImportPolicyInfo"
                >保单批量维护</el-button
              >
            </div>
            <div class="entry-row">
              <p class="entry-title">批量上传保单附件</p>
              <p class="entry-desc">
                系统中已经存在此保单信息，批量进行车辆保单附件上传。
              </p>
              <el-button
                class="entry-btn"
                type="primary"
                icon="el-icon-upload2"
                plain
                @click="handleBatchImportPolicyFile"
                >批量上传保单附件</el-button
              >
            </div>
            <div class="entry-row">
              <p class="entry-title">批量停复保</p>
              <p class="entry-desc">对系统中已经存在的保单信息，批量操作保单状态变更。</p>
              <el-button
                class="entry-btn"
                type="primary"
                icon="el-icon-time"
                plain
                @click="handleBatchImportInsurancePolicy"
              >
              批量上传停复保信息
            </el-button>
            </div>
            <div class="entry-row">
              <p class="entry-title">查看录入记录</p>
              <p class="entry-desc">查看已提交的任务记录导入进度。</p>
              <el-button
                class="entry-btn"
                type="primary"
                icon="el-icon-time"
                plain
                @click="handleViewImportInsurancePolicyLog"
                >查看录入记录</el-button
              >
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <component
      v-if="currentModalComponent"
      :is="currentModalComponent"
      :visible="currentModalComponentVisible"
      @toggleDialogVisible="handleToggleDialogVisible"
    >
    </component>
  </div>
</template>

<script>
import BatchImportCarInfo from './components/batchImportCarInfo.vue'
import BatchImportInStock from './components/batchImportInStock.vue'
import BatchImportLicense from './components/batchImportLicense.vue'
import BatchImportPolicyInfo from './components/batchImportPolicyInfo.vue'
import BatchImportPolicyFile from './components/batchImportPolicyFile.vue'
import BatchImportInsurancePolicy from './components/batchImportInsurancePolicy.vue'

/**
 * scene 代表场景
*/
const sceneMapper = new Map([
  ['licencesList', 'licenseTransact'],
  ['insuranceList', 'insuranceTransact'],
])

export default {
  data() {
    return {
      activeTabName: 'createAndInStock',
      currentModalComponent: '',
      currentModalComponentVisible: false,
    }
  },
  methods: {
    handleToggleDialogVisible(visible) {
      if (!visible) {
        this.currentModalComponentVisible = false
        this.currentModalComponent = ''
      }
    },
    // 批量录入车辆
    handleBatchImportCarInfo() {
      this.currentModalComponent = 'BatchImportCarInfo'
      this.currentModalComponentVisible = true
    },
    // 查看车辆信息录入记录
    handleViewImportCarLog() {
      this.$router.push({
        name: 'vehicleInfoImportHistory',
      })
    },
    // 批量录入证照
    handleBatchImportLicense() {
      this.currentModalComponent = 'BatchImportLicense'
      this.currentModalComponentVisible = true
    },
    // 查看证照图片录入记录
    handleViewImportLicenseLog() {
      this.$router.push({
        name: 'vehicleImageImportHistory',
      })
    },
    // 保单批量维护
    handleBatchImportPolicyInfo() {
      this.currentModalComponent = 'BatchImportPolicyInfo'
      this.currentModalComponentVisible = true
    },
    // 批量上传保单附件
    handleBatchImportPolicyFile() {
      this.currentModalComponent = 'BatchImportPolicyFile'
      this.currentModalComponentVisible = true
    },
    // 查看保险信息录入记录
    handleViewImportInsurancePolicyLog() {
      this.$router.push({
        name: 'policyImportHistory',
      })
    },
    // 批量上传停复保
    handleBatchImportInsurancePolicy() {
      this.currentModalComponent = 'BatchImportInsurancePolicy'
      this.currentModalComponentVisible = true
    },
  },
  components: {
    BatchImportCarInfo,
    BatchImportInStock,
    BatchImportLicense,
    BatchImportPolicyInfo,
    BatchImportPolicyFile,
    BatchImportInsurancePolicy,
  },
  mounted() {
    // 判断当前 页面开启是否是场景开启
    const scene = this.$route.query?.scene
    if (scene && sceneMapper.get(scene)) {
      this.activeTabName = sceneMapper.get(scene)
    }
  },
}
</script>

<style lang="scss" scoped>
.batch-in-stock {
  height: 100%;
  ::v-deep .el-tabs {
    display: flex;
    flex-direction: column;
    height: 100%;
    .el-tabs__header {
      flex: 0;
    }
    .el-tabs__content {
      flex: 1;
    }
  }
}
.tab-pane {
  .entry-list {
    display: flex;
    flex-wrap: wrap;
    gap: 19px;
    padding-top: 8px;
    .entry-row {
      min-width: 320px;
      width: calc((100% - 38px) / 3);
      display: grid;
      flex-direction: column;
      align-items: flex-start;
      padding: 24px;
      background: #f4f8ff;
      border-radius: 4px;
      &.hidden {
        visibility: hidden;
      }
      .entry-title {
        margin: 0;
        font-size: 18px;
        font-weight: 500;
        color: #3d3d3d;
      }
      .entry-desc {
        margin: 8px 0 26px 0;
        height: 40px;
        line-height: 20px;
      }
      .entry-btn {
        justify-self: self-start;
        align-self: self-end;
      }
    }
  }
}
</style>
